<template>
  <v-container
      class="mb-7"
  >
    <v-row
        v-for="(project, index) in projects"
        :key="index"
        :cols="12"
        :class="{'flex-row-reverse': index % 2 !== 1}"
    >
      <v-col
          cols="12"
          md="6"
      >
        <v-card
            :title="project.name"
            height="100%"
        >
          <v-card-text>
            <span v-html="project.description" class="description"></span>
          </v-card-text>
          <v-card-actions
              style="position: absolute; bottom: 0"
          >
            <v-chip
                v-for="tech in project.technologies"
                :key="tech"
                color="primary"
                class="mr-2"
            >
              {{ tech }}
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
          cols="12"
          md="6"
      >
        <GalleryComponent :gallery="project.gallery "/>
      </v-col>
      <v-divider/>
    </v-row>
  </v-container>
</template>

<script>

import GalleryComponent from '@/components/Gallery'

export default {
  name: 'ProjectsComponent',
  components: { GalleryComponent },
  data () {
    return {
      projects: [
        {
          name: 'F1 Telemetry',
          description: '<p>Desktop application created in WxPython for displaying telemetry and additional information obtained ' +
              'from the official F1 game using the built-in UDP telemetry feature.</p><p>The telemetry graphs are created using ' +
              'Matplotlib library and shows basic information, such as the current speed, throttle trace, brake trace, steering angle ' +
              'and selected gear.</p><p>In addition, it also shows the live order that gets updated every time a packet is received, ' +
              'the current weather and laps elapsed/remaining or session time.</p><p>Based on the coordinates of each car, the real-time ' +
              'position is shown on a track map along with driver abbreviations.</p><p>Originally developed for F1 2020 but ' +
              'could be modified to be compatible with any newer or older F1 game.</p><p>For further information about the packet ' +
              'specification check <a href="https://answers.ea.com/t5/General-Discussion/F1-22-UDP-Specification/td-p/11551274?attachment-id=657933" target="_blank">' +
              'here</a>.</p>',
          technologies: ['Python', 'wxPython', 'Matplotlib'],
          gallery: [
            {
              image: 'f1_telemetry/telemetry_app.png',
              caption: 'Main window of the F1 telemetry app for the official F1 game'
            },
            {
              image: 'f1_telemetry/traces.png',
              caption: 'Telemetry showing current speed, throttle and brake traces, selected gear, steering angle and a comparison with previous lap'
            },
            {
              image: 'f1_telemetry/map.png',
              caption: 'Circuit map showing live positions of all active cars'
            }
          ]
        },
        {
          name: 'Twitter Alt Text Bot',
          description: '<p>A Twitter bot that extracts text from images. Twitter still does not do this automatically' +
              ' and requires users to input the alt text manually.</p><p>Users can respond to a tweet that contains ' +
              'an image by tagging the bot, it then detects the language in the image using <i>langdetect</i> library and ' +
              'extracts it using the <i>Pytesseract</i> library. This approach works very well for screenshots of news ' +
              'articles and other images with clearly visible text.</p><p>After the text is extracted, we reply to the user by ' +
              'tweeting the same image with the extracted text included as the alt text.</p><p>Killed in 2023 by Elon Musk ' +
              'and his $1000 month API access. RIP</p>',
          technologies: ['Python', 'Twitter API', 'Pytesseract', 'Google language detection library'],
          gallery: [
            {
              image: 'dead_twitter.jpg',
              caption: 'Good job, Elon'
            }
          ]
        },
        {
          name: 'Messenger Emotes',
          description: '<p>A chrome extension that allows the use of Twitch emotes on Messenger.</p><p>Every time the chat ' +
              'windows gets updated, the extension examines all newly added messages and replaces all strings corresponding to ' +
              'emotes with appropriate images.</p><p>Users can hover over the image to display the string representation of that emote.</p>' +
              '<p>The extension can easily be turned off in the extension setting, where users can also disable the hover funcionality.</p>' +
              '<p>The full list of available emotes can be seen <a href="https://betterttv.com/emotes/popular" target="_blank">here</a>.</p>',
          technologies: ['JavaScript', 'Chrome extensions'],
          gallery: [
            {
              image: '/messenger/sample_text.png',
              caption: 'Sample message showing Twitch emotes displayed in Messenger chat'
            },
            {
              image: 'messenger/hover.png',
              caption: 'Hovering over an image displays the text of the emote'
            },
            {
              image: 'messenger/settings.png',
              caption: 'The functionality can be disabled in a simple menu'
            }
          ]
        },
        {
          name: 'Wordament ChatGPT Solver',
          description: '<p>A little experiment to test out the capabilities of ChatGPT to create a simple web app with a single API endpoint ' +
              'without much additional help. Created using ChatGPT v3.5.</p><p>It works as a solver for the Wordament game, in which users ' +
              'look for words in a 4x4 matrix, which can be created using a single motion, without going over the same letter multiple times.</p>' +
              '<p>The entered matrix gets sent to the server, where we run a simple DFS to find all words with lengths at least 3. We then cross-reference ' +
              'the obtained words with an English dictionary, to filter out only words that are valid.</p><p>Overall, ChatGPT was able to create ' +
              'the backend with no issues but struggled with creating a user-friendly interface for inputting the matrix.</p>' +
              '<p>The website is available <a href="https://wordament-gpt.vercel.app/" target="_blank">here</a>. It was also meant to be ' +
              'responsive but some elements might not work as expected.</p>',
          technologies: ['Flask', 'Vue.js'],
          gallery: [
            {
              image: '/wordament/wordament_main.png',
              caption: 'The home page of the Wordament Solver app'
            },
            {
              image: '/wordament/wordament_solved.png',
              caption: 'All words found in the 4x4 matrix that have the given length'
            }
          ]
        },
        {
          name: 'Engine Analysis',
          description: '<p>A software that takes data from measurements of a combustion car engine and creates some plots ' +
              'with relevant information.</p>',
          technologies: ['Python', 'Matplotlib'],
          gallery: [
            {
              image: '/analysis/1.png',
              caption: ''
            },
            {
              image: '/analysis/2.png',
              caption: ''
            },
            {
              image: '/analysis/3.png',
              caption: ''
            }
          ]
        }
      ]
    }
  }
}
</script>

<style>

</style>
